import { supabase } from '../lib/supabase';
import { SUPABASE_NOT_CONFIGURED_MSG } from '../lib/envConfig';

const assertSupabase = () => {
  if (!supabase) throw new Error(SUPABASE_NOT_CONFIGURED_MSG);
};

// ─── Promotions ───────────────────────────────────────────────────────────────

export const fetchPromotions = async (activeOnly = false) => {
  if (!supabase) return [];
  let query = supabase?.from('promotions')?.select('*')?.order('sort_order', { ascending: true });
  if (activeOnly) {
    query = query?.eq('active', true);
  }
  const { data, error } = await query;
  if (error) throw error;
  return data?.map(dbPromoToApp);
};

export const addPromotion = async (promo) => {
  assertSupabase();
  const { data: existing } = await supabase
    ?.from('promotions')
    ?.select('sort_order')
    ?.order('sort_order', { ascending: false })
    ?.limit(1)
    ?.single();
  const sortOrder = (existing?.sort_order || 0) + 1;

  const payload = {
    title: promo?.title || '',
    description: promo?.description || '',
    image_url: promo?.imageUrl || '',
    sort_order: sortOrder,
    active: promo?.active !== undefined ? promo?.active : true,
    updated_at: new Date()?.toISOString(),
  };

  const { data, error } = await supabase?.from('promotions')?.insert(payload)?.select()?.single();
  if (error) throw error;
  return dbPromoToApp(data);
};

export const updatePromotion = async (id, promo) => {
  assertSupabase();
  const payload = {
    title: promo?.title || '',
    description: promo?.description || '',
    image_url: promo?.imageUrl || '',
    active: promo?.active !== undefined ? promo?.active : true,
    updated_at: new Date()?.toISOString(),
  };
  const { error } = await supabase?.from('promotions')?.update(payload)?.eq('id', id);
  if (error) throw error;
};

export const deletePromotion = async (id) => {
  assertSupabase();
  const { error } = await supabase?.from('promotions')?.delete()?.eq('id', id);
  if (error) throw error;
};

export const subscribeToPromotions = (callback) => {
  if (!supabase) return null;
  return supabase
    ?.channel('promotions_changes')
    ?.on('postgres_changes', { event: '*', schema: 'public', table: 'promotions' }, callback)
    ?.subscribe();
};

// ─── Converter ────────────────────────────────────────────────────────────────

function dbPromoToApp(d) {
  return {
    id: d?.id,
    title: d?.title || '',
    description: d?.description || '',
    imageUrl: d?.image_url || '',
    sortOrder: d?.sort_order || 0,
    active: d?.active !== false,
    createdAt: d?.created_at,
    updatedAt: d?.updated_at,
  };
}
